<template>
  <div id="playerAnalysis" class="container is-fluid" :class="getUserType == 0 ? 'margin-flag-b2c' : ''">
    <br />
    <!-- Header -->
    <div class="columns">
      <div class="column is-12">
        <HeaderFigma :player="player" v-model="playerSection" />
      </div>
    </div>
    <!-- Filters -->
    <div class="player-analysis__filters">
      <div class="is-hidden-mobile">
        <PlayerFilter
          @statisticsChanged="onStatisticsChanged"
          @playingAsChanged="onPlayingAsChanged"
          @resultsChanged="onResultsChanged"
          @sectionsChanged="onSectionsChanged"
          :class="playerSection === 4 ? 'hidden-filters' : ''"
        />
      </div>
      <div class="player-analysis__filters__mobile">
        <!--        <button class="button filter-button is-dark" style="display: none">-->
        <!--          <BIcon icon="tune"> </BIcon>-->
        <!--          <span>EXPORTAR INFO</span>-->
        <!--        </button>-->
        <div class="player-team" :class="playerSection === 4 ? 'hidden-borders' : ''" v-if="hasPlayerNationalTeam">
          <span @click="setIsPlayerNationalTeam(false)" class="is-clickable" style="margin-right: 12px;">CLUB</span>
          <BSwitch :value="isPlayerNationalTeam" passive-type="is-primary" @input="setIsPlayerNationalTeam" />
          <span class="is-clickable" @click="setIsPlayerNationalTeam(true)">SELECCIÓN</span>
        </div>
        <button
          class="button filter-button is-primary"
          :class="playerSection === 4 ? 'hidden-filters' : ''"
          @click="onClickFilterMobile"
        >
          <BIcon icon="tune"> </BIcon>
          <span>{{ $t('general.filters') }}</span>
        </button>
        <FilterMobile
          :class="playerSection === 4 ? 'hidden-filters' : ''"
          @statisticsChanged="onStatisticsChanged"
          @playingAsChanged="onPlayingAsChanged"
          @resultsChanged="onResultsChanged"
          @sectionsChanged="onSectionsChanged"
          :show-modal="showMobileFilter"
          @hide="showMobileFilter = false"
        />
      </div>
    </div>
    <!-- Sections -->
    <div v-if="playerSection === 1">
      <PlayerPossession />
    </div>
    <div v-else-if="playerSection === 2">
      <PlayerOffensive />
    </div>
    <div v-else-if="playerSection === 4">
      <PlayerSummary :key="update" />
    </div>
    <div v-else>
      <PlayerDefensive />
    </div>
  </div>
</template>

<script>
import PlayerFilter from '@/components/NavBars/Filter';
import HeaderFigma from '@/views/HeaderFigma';
import PlayerPossession from '@/components/Sections/Player/Possession';
import PlayerSummary from '@/components/Sections/Player/Summary';
import PlayerOffensive from '@/components/Sections/Player/Offensive';
import PlayerDefensive from '@/components/Sections/Player/Defensive';
import FilterMobile from '@/components/Elements/FilterMobile';
import { mapGetters, mapMutations, mapState } from 'vuex';
import {
  analisisDeJugadorPosesion,
  analisisDeJugadorOfensivo,
  analisisDeJugadorDefensivo,
  analisisDeJugadorFiltros,
  analisisDeJugadorFiltroTemporada,
  analisisDeJugadorFiltroEstadistica,
  analisisDeJugadorFiltroJugadoComo,
  analisisDeJugadorFiltroPorResultado,
  analisisDeJugadorFiltroPorTiempo,
} from '@/utils/analytics/players';

export default {
  components: {
    PlayerDefensive,
    HeaderFigma,
    PlayerFilter,
    PlayerSummary,
    PlayerPossession,
    PlayerOffensive,
    FilterMobile,
  },
  data() {
    return {
      showMobileFilter: false,
      playerSection: 4,
      update: 0,
    };
  },
  created() {
    this.onCreated();
  },
  mounted() {
    this.onMounted();
  },
  watch: {
    playerSection() {
      this.setCategoryType();
    },
    player: {
      deep: true,
      handler(newValue) {
        if (this.player.teamName) {
          window.localStorage.setItem('LTeamForPlayersView', this.player.team_id);
          window.localStorage.setItem('LTeamNameForPlayersView', this.player.teamName);
        }
        if (newValue.position_id === 1) {
          this.playerSection = 4;
        }
      },
    },
    seasonId() {
      this.updateStatisticData(null);
      this.$store.dispatch('playersGeneral/cleanData');
      this.$store.dispatch('playersGeneral/checkStateSummary', {
        seasonNumber: Number(this.seasonId),
        playerId: Number(this.$route.params.playerId),
      });
    },
    '$route.params': {
      deep: true,
      handler() {
        this.onBeforeDestroy();
        this.onCreated();
      },
    },
  },
  computed: {
    ...mapState('filterGeneral', ['hasPlayerNationalTeam', 'isPlayerNationalTeam', 'nationalSeasons']),
    ...mapGetters('playersGeneral', ['player']),
    ...mapGetters('loginGeneral', ['getUserType']),
    ...mapState('playersGeneral', ['loadCount']),
    ...mapGetters({ seasonId: 'filterGeneral/getSeasonId', section: 'filterGeneral/getCategoryTypeName' }),
    teamId() {
      return this.player.team_id || 0;
    },
    playerId() {
      return this.player.player_id || 0;
    },
  },
  methods: {
    ...mapMutations('filterGeneral', ['setStadisticId', 'setIsPlayerNationalTeam']),
    async onCreated() {
      try {
        this.setCategoryType();
        this.$store.dispatch('playersGeneral/cleanData');
        await this.$store.dispatch('playersGeneral/checkState', {
          seasonId: Number(this.$route.params.seasonId),
          playerId: Number(this.$route.params.playerId),
        });
      } catch (e) {
        console.error(e);
      }
    },
    onMounted() {
      window.scrollTo(0, 0);
      this.$store.commit('teamsGeneral/updateTeam', {});
    },
    onBeforeDestroy() {
      this.setStadisticId(1);
      this.setIsPlayerNationalTeam(false);
    },
    /**
     * @param {number} teamClass - possible values are 1 for national or 0 for club
     */
    updateStatisticData(teamClass) {
      analisisDeJugadorFiltroTemporada(this.seasonId, this.teamId, this.playerId, this.section);
      try {
        this.$store.dispatch('playersGeneral/fillStatisticData', { teamClass, promises: [undefined] });
      } catch (e) {
        console.error('Error, Player updateStatisticData: ', e);
      }
    },
    /**
     * @author José Rafael Gutierrez
     * Set property sections in filterGeneral module.
     * @return void
     */
    setCategoryType() {
      if (this.teamId && this.seasonId && this.playerId) {
        switch (this.playerSection) {
          case 1:
            analisisDeJugadorPosesion(this.seasonId, this.teamId, this.playerId);
            break;
          case 2:
            analisisDeJugadorOfensivo(this.seasonId, this.teamId, this.playerId);
            break;
          case 3:
            analisisDeJugadorDefensivo(this.seasonId, this.teamId, this.playerId);
            break;
        }
      }
      this.update += 1;
      this.$store.commit('filterGeneral/setCategoryType', this.playerSection);
    },
    /**
     * @author Rigoberto Sanchez
     * @description
     */
    onClickFilterMobile() {
      analisisDeJugadorFiltros(this.seasonId, this.teamId, this.playerId, this.section);
      this.showMobileFilter = true;
    },
    onStatisticsChanged(value) {
      analisisDeJugadorFiltroEstadistica(this.seasonId, this.teamId, this.playerId, this.section, value);
    },
    onPlayingAsChanged(value) {
      analisisDeJugadorFiltroJugadoComo(this.seasonId, this.teamId, this.playerId, this.section, value);
    },
    onResultsChanged(value) {
      analisisDeJugadorFiltroPorResultado(this.seasonId, this.teamId, this.playerId, this.section, value);
    },
    onSectionsChanged(value) {
      analisisDeJugadorFiltroPorTiempo(this.seasonId, this.teamId, this.playerId, this.section, value);
    },
  },
  beforeDestroy() {
    this.onBeforeDestroy();
  },
};
</script>

<style scoped lang="scss">
.margin-flag-b2c {
  // margin-top: 72px !important;
}
.hidden-filters {
  display: none !important;
}
.hidden-borders {
  border: 0px solid black !important;
  display: none !important;
  @media (max-width: 680px) {
    display: flex !important;
  }
}
#playerAnalysis {
  & div.columns {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
}
.player-analysis__filters {
  margin-bottom: 8px;

  &__mobile {
    display: none;

    justify-content: space-around;
    align-items: center;
    @media (max-width: 768px) {
      display: flex;
    }

    & > div.player-team {
      padding: 0.3em 1em;
      border-radius: 6px;
      border: solid 2px #d2d5da;
      color: black;

      & > span {
        padding-top: 0.2em;
      }
    }
  }
}
.filter-button {
  margin: 5px;
  text-transform: uppercase;
}
.is-hidden-tablet > .filter-button:first-child {
  visibility: hidden;
}
</style>
